import React from "react";
import { Box } from "@mui/joy";
import DarkCard from "../../common/DarkCard";
import DarkTypography from "../../common/DarkTypography";

type SettingsSectionCardProps = {
  title: string;
  titleEnd?: React.ReactNode;
  children: React.ReactNode;
  sx?: React.ComponentProps<typeof DarkCard>["sx"];
};

export default function SettingsSectionCard({
  title,
  titleEnd,
  children,
  sx,
}: SettingsSectionCardProps) {
  return (
    <DarkCard dense sx={{ maxWidth: "100%", ...sx }}>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "flex-start",
          justifyContent: "space-between",
          gap: 1,
          mb: { xs: 1.25, sm: 1.5 },
          minWidth: 0,
        }}
      >
        <DarkTypography
          level="title-sm"
          colorVariant="title"
          sx={{ minWidth: 0, flex: "1 1 auto" }}
        >
          {title}
        </DarkTypography>
        {titleEnd != null ? <Box sx={{ flexShrink: 0 }}>{titleEnd}</Box> : null}
      </Box>
      <Box sx={{ maxWidth: "100%" }}>{children}</Box>
    </DarkCard>
  );
}
